/**
 * FacebookTokenTypes represents the different types of tokens that can be stored in the Database. 
 * SOCIAL_SHARING type are tokens that has a valid token to perform social sharing actions.
 * SOCIAL_SHARING_RECOMMENDATIONS type are tokens that has a valid token to perform both social sharing and recommendations actions.
 */
export enum FacebookTokenTypes {
    SOCIAL_SHARING = 'SOCIAL_SHARING',
    SOCIAL_SHARING_RECOMMENDATIONS = 'SOCIAL_SHARING_RECOMMENDATIONS'
}